import {StyleSheet} from 'react-native';

// Helper function to get responsive values
export const getResponsiveValue = (screenWidth, mobile, tablet, desktop) => {
  if (screenWidth < 768) return mobile;
  if (screenWidth < 1024) return tablet;
  return desktop;
};

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    borderColor: '#687C90',
    borderWidth: 2,
    position: 'relative',
    marginTop: 20
  },
  header: {
    fontWeight: 'bold',
    color: '#FFFFFF',
    marginBottom: '3%',
    marginLeft: 10
  },
  zonesContainer: {
    flex: 1
  },
  zoneContainer: {
    borderRadius: 15,
    borderColor: '#687C90',
    borderWidth: 2,
    position: 'relative',
    zIndex: 1
  },
  zoneHeader: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 15
  },
  zoneTitle: {
    fontFamily: 'Poppins_600SemiBold',
    fontWeight: 'bold',
    color: '#FFFFFF'
  },
  zoneTitleInput: {
    fontFamily: 'Poppins_600SemiBold',
    fontWeight: 'bold',
    color: '#FFFFFF',
    backgroundColor: 'transparent',
    borderBottomWidth: 1,
    borderBottomColor: '#FFFFFF',
    paddingVertical: 5,
    minWidth: 100
  },
  iconButton: {
    borderRadius: 5
  },
  rangeRow: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'center'
  },
  deleteButton: {
    width: 30,
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 0
  },
  rangeInputsContainer: {
    flexDirection: 'row',
    alignItems: 'flex-end'
  },
  rangeInputWrapper: {
    // Width set dynamically based on screen size
  },
  rangeLabel: {
    fontFamily: 'Poppins_300Light',
    color: '#FFFFFF',
    textAlign: 'center'
  },
  rangeInput: {
    backgroundColor: '#FFFFFF',
    borderRadius: 5,
    textAlign: 'center'
  },
  addRangeButton: {
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 5,
    borderWidth: 1,
    borderColor: '#FFFFFF',
    marginHorizontal: 'auto',
    justifyContent: 'center'
  },
  addRangeText: {
    fontFamily: 'Poppins_300Light',
    color: '#FFFFFF',
    marginLeft: 5
  },
  addZoneButton: {
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 5,
    alignSelf: 'center',
    borderWidth: 1,
    borderColor: '#FFFFFF'
  },
  addZoneText: {
    fontFamily: 'Poppins_300Light',
    color: '#FFFFFF',
    marginLeft: 5
  },
  infoDescriptionContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  infoDescriptionText: {
    fontFamily: 'Poppins_300Light',
    color: '#FFFFFF'
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: 'transparent'
  },
  tooltipContainer: {
    borderRadius: 5,
    alignSelf: 'flex-start',
    zIndex: 99,
    elevation: 5
  },
  tooltipText: {
    color: '#000000',
    lineHeight: 18
  },
  tooltipArrow: {
    position: 'absolute',
    width: 0,
    height: 0,
    borderLeftWidth: 10,
    borderLeftColor: 'transparent',
    borderRightWidth: 10,
    borderRightColor: 'transparent',
    borderBottomWidth: 10,
    borderBottomColor: '#8a9daf'
  }
});

export const getZoneSettingsStyles = (screenWidth) => {
  const containerPadding = getResponsiveValue(screenWidth, 8, 14, 18);
  const containerBorderRadius = getResponsiveValue(screenWidth, 15, 20, 25);
  const headerFontSize = getResponsiveValue(screenWidth, 18, 20, 24);
  const addZoneIconSize = getResponsiveValue(screenWidth, 20, 22, 25);
  const addZoneTextFontSize = getResponsiveValue(screenWidth, 11, 12, 14);
  const addZoneButtonPadding = getResponsiveValue(screenWidth, 4, 5, 5);
  const addZoneButtonMarginTop = getResponsiveValue(screenWidth, 15, 18, 20);

  return {
    container: {
      padding: containerPadding,
      borderRadius: containerBorderRadius
    },
    header: {
      fontSize: headerFontSize
    },
    addZoneButton: {
      padding: addZoneButtonPadding,
      marginTop: addZoneButtonMarginTop
    },
    addZoneText: {
      fontSize: addZoneTextFontSize
    },
    addZoneIconSize
  };
};

export const getZoneCardStyles = (screenWidth) => {
  const zoneTitleFontSize = getResponsiveValue(screenWidth, 16, 18, 20);
  const iconSize = getResponsiveValue(screenWidth, 18, 20, 22);
  const editIconSize = getResponsiveValue(screenWidth, 18, 20, 20);
  const deleteIconSize = getResponsiveValue(screenWidth, 20, 22, 24);
  const addIconSize = getResponsiveValue(screenWidth, 16, 18, 18);
  const rangeLabelFontSize = getResponsiveValue(screenWidth, 12, 13, 14);
  const rangeInputFontSize = getResponsiveValue(screenWidth, 14, 15, 16);
  const rangeInputHeight = getResponsiveValue(screenWidth, 36, 38, 40);
  const buttonTextFontSize = getResponsiveValue(screenWidth, 11, 12, 14);
  const tooltipFontSize = getResponsiveValue(screenWidth, 11, 12, 12);
  const tooltipWidth = getResponsiveValue(screenWidth, 250, 280, 300);

  const containerPadding = getResponsiveValue(screenWidth, 10, 12, 15);
  const containerMarginBottom = getResponsiveValue(screenWidth, 12, 16, 20);
  const headerMarginBottom = getResponsiveValue(screenWidth, 10, 12, 15);
  const iconButtonPadding = getResponsiveValue(screenWidth, 6, 7, 8);
  const iconButtonMarginLeft = getResponsiveValue(screenWidth, 8, 9, 10);
  const rangeRowMarginBottom = getResponsiveValue(screenWidth, 10, 12, 15);
  const rangeRowPaddingHorizontal = getResponsiveValue(screenWidth, 5, 8, 10);
  const rangeRowGap = getResponsiveValue(screenWidth, 6, 8, 10);
  const rangeInputsGap = getResponsiveValue(screenWidth, 4, 8, 10);
  const rangeLabelMarginBottom = getResponsiveValue(screenWidth, 3, 4, 5);
  const rangeInputPaddingHorizontal = getResponsiveValue(screenWidth, 4, 8, 10);
  const rangeInputWidth = getResponsiveValue(screenWidth, 120, 150, 150);
  const buttonPadding = getResponsiveValue(screenWidth, 4, 5, 5);
  const buttonMarginTop = getResponsiveValue(screenWidth, 8, 9, 10);
  const infoContainerMarginBottom = getResponsiveValue(screenWidth, 10, 12, 15);
  const infoContainerPaddingHorizontal = getResponsiveValue(screenWidth, 5, 8, 10);
  const infoContainerGap = getResponsiveValue(screenWidth, 6, 8, 10);
  const infoTextFontSize = getResponsiveValue(screenWidth, 12, 13, 14);
  const tooltipPadding = getResponsiveValue(screenWidth, 8, 9, 10);

  return {
    zoneContainer: {
      padding: containerPadding,
      marginBottom: containerMarginBottom
    },
    zoneHeader: {
      marginBottom: headerMarginBottom
    },
    zoneTitle: {
      fontSize: zoneTitleFontSize
    },
    zoneTitleInput: {
      fontSize: zoneTitleFontSize,
      flex: 1
    },
    iconButton: {
      padding: iconButtonPadding,
      marginLeft: iconButtonMarginLeft
    },
    infoDescriptionContainer: {
      marginBottom: infoContainerMarginBottom,
      paddingHorizontal: infoContainerPaddingHorizontal,
      gap: infoContainerGap
    },
    infoDescriptionText: {
      fontSize: infoTextFontSize
    },
    rangeRow: {
      marginBottom: rangeRowMarginBottom,
      paddingHorizontal: rangeRowPaddingHorizontal,
      gap: rangeRowGap
    },
    rangeInputsContainer: {
      gap: rangeInputsGap
    },
    rangeLabel: {
      fontSize: rangeLabelFontSize,
      marginBottom: rangeLabelMarginBottom
    },
    rangeInputWrapper: {
      width: rangeInputWidth
    },
    rangeInput: {
      height: rangeInputHeight,
      fontSize: rangeInputFontSize,
      paddingHorizontal: rangeInputPaddingHorizontal
    },
    addRangeButton: {
      padding: buttonPadding,
      marginTop: buttonMarginTop
    },
    addRangeText: {
      fontSize: buttonTextFontSize
    },
    tooltipContainer: {
      width: tooltipWidth,
      padding: tooltipPadding
    },
    tooltipText: {
      fontSize: tooltipFontSize
    },
    tooltipWidth,
    iconSizes: {
      info: iconSize,
      edit: editIconSize,
      delete: deleteIconSize,
      add: addIconSize
    }
  };
};

